import { ref as C, watch as S, toValue as f, onMounted as L } from "vue";
function O(w) {
  const {
    elementRef: W,
    text: x,
    suffix: T,
    ellipsis: m = "...",
    minSideLength: p = 1
  } = w || {}, l = C("");
  let b = null;
  const c = (n, i) => {
    const e = document.createElement("span"), t = window.getComputedStyle(i);
    e.style.position = "absolute", e.style.visibility = "hidden", e.style.whiteSpace = "nowrap", e.style.pointerEvents = "none", e.style.left = "-9999px", e.style.top = "-9999px", e.style.font = t.font, e.style.fontSize = t.fontSize, e.style.fontFamily = t.fontFamily, e.style.fontWeight = t.fontWeight, e.style.letterSpacing = t.letterSpacing, e.style.textTransform = t.textTransform, e.textContent = n, document.body.appendChild(e);
    const { width: y } = e.getBoundingClientRect();
    return document.body.removeChild(e), y;
  }, a = () => {
    const n = W.value;
    if (!n) {
      l.value = f(x);
      return;
    }
    const i = f(x), e = f(T) || "";
    if (!i) {
      l.value = "";
      return;
    }
    let t = i;
    if (e) {
      const u = ` ${e}`;
      i.endsWith(u) ? t = i.slice(0, -u.length) : i.endsWith(e) && (t = i.slice(0, -e.length));
    }
    t = t.trimEnd();
    const y = n.clientWidth, z = e ? c(e, n) : 0, d = y - z;
    if (d <= 0) {
      l.value = t;
      return;
    }
    if (c(t, n) <= d) {
      l.value = t;
      return;
    }
    const r = t.length;
    if (p * 2 >= r) {
      l.value = t;
      return;
    }
    let s = p, o = p, h = t.slice(0, s) + m + t.slice(r - o), v = c(h, n);
    if (v > d) {
      l.value = h;
      return;
    }
    for (; s + o < r; ) {
      const u = s <= o ? s + 1 : s, g = s <= o ? o : o + 1;
      if (u + g >= r) {
        l.value = t;
        return;
      }
      if (h = t.slice(0, u) + m + t.slice(r - g), v = c(h, n), v <= d)
        s = u, o = g;
      else
        break;
    }
    l.value = t.slice(0, s) + m + t.slice(r - o);
  };
  return S(() => f(x), a, {
    flush: "post"
  }), S(() => f(T), a, {
    flush: "post"
  }), L(() => {
    const n = W.value;
    n && typeof ResizeObserver < "u" && (b = new ResizeObserver(() => {
      a();
    }), b.observe(n)), a();
  }), {
    truncatedText: l
  };
}
export {
  O as useTruncateMiddle
};
